import React from 'react';
import {
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Row,
  Col
} from 'react-bootstrap';
import axios from '../../libs/axios_csrf';
import { Goals } from './GoalConstants';
import { injectIntl } from 'react-intl';
import { STARTUP_ROLES } from './authorization/constants';
import { BMC_STAGES } from './bmc/bmc_constants';
import RootStore from '../bmc_components/stores/RootStore';
import { camelCase } from '@ridi/object-case-converter';
import { observer } from 'mobx-react';
import { extendObservable } from 'mobx';
import { withRouter } from 'react-router-dom';
import { DASHBOARD_TYPES } from '../dashboard_components/constants';
import { bmcPermissions } from './wrappers/functions';

const getVps = (params = {}) => axios.get('/value_propositions.json', params);

const updatePreferenceStage = (preferenceId, stage) => {
  return axios.patch(`/bmc_board_preferences/${preferenceId}.json`, {
    bmc_board_preference: { current_stage: stage }
  });
};

@injectIntl
@withRouter
@observer
export default class ValuePropositionSelect extends React.Component {
  static defaultProps = {
    userRoles: []
  };

  constructor(props) {
    super(props);

    this.state = {
      valuePropositions: [],
      currentValuePropositionId: null,
      currentBoardStage: '',
      currentBoardId: null,
      currentBoardPreferenceId: null,
      align: props.align || 'center',

      updatingCurrStage: false
    };

    extendObservable(this, {
      bmcStore: null
    });

    this.currentValueProposition = this.currentValueProposition.bind(this);
  }

  async componentDidMount() {
    const { userRoles, intl } = this.props;

    const response = await getVps({});

    this.setState({
      valuePropositions: response.data.value_propositions,
      currentValuePropositionId: response.data.current_value_proposition_id,
      currentBoardId: response.data.current_board_id,
      currentBoardStage: response.data.current_board_stage,
      currentBoardPreferenceId: response.data.current_board_preference_id
    });

    const permissions = await bmcPermissions(response.data.current_board_id);

    this.bmcStore = new RootStore({
      bmcId: response.data.current_board_id,
      currentUserPermission: camelCase(permissions),
      currentUserRoles: userRoles,
      userLocale: intl.locale
    });

    this.bmcStore.localeStore = {
      intl: this.props.intl
    };

    return this.bmcStore.fetchData(true);
  }

  currentValueProposition() {
    const { currentValuePropositionId, valuePropositions } = this.state;

    return valuePropositions.find(({ id }) => id === currentValuePropositionId);
  }

  cannotUpdateCurrentGoal = () => {
    const {
      userRoles,
      location: { pathname }
    } = this.props;

    return (
      !(
        pathname.includes('dashboards') &&
        pathname.includes(DASHBOARD_TYPES.BUSINESS)
      ) || !userRoles.includes(STARTUP_ROLES.CEO)
    );
  };

  cannotUpdateToC = () => {
    const {
      userRoles,
      location: { pathname }
    } = this.props;

    return (
      !(
        pathname.includes('dashboards') &&
        pathname.includes(DASHBOARD_TYPES.BUSINESS)
      ) || !userRoles.includes(STARTUP_ROLES.CEO)
    );
  };

  updateCurrentBmcStage = async stage => {
    const { currentBoardPreferenceId } = this.state;

    // console.log('STAGE', stage);
    this.setState({ updatingCurrStage: true });

    // await updatePreferenceStage(currentBoardPreferenceId, stage);

    this.bmcStore.setCurrentStage(stage, () => window.location.reload());
  };

  render() {
    const {
      valuePropositions,
      align,
      currentBoardStage,
      currentBoardId,
      updatingCurrStage
    } = this.state;
    const { title, intl } = this.props;

    const vp = this.currentValueProposition();

    return (
      <div>
        <Row id="vp-selector-container">
          <Col xs={12} md={4} className="vp-dropdown">
            {title && vp && (
              <p
                title={intl.formatMessage({
                  id: 'value_proposition_change'
                })}
                className="vp-picker"
              >
                {intl.formatMessage({ id: 'value_proposition_title' })}
              </p>
            )}
            {vp && (
              <DropdownButton
                pullRight
                title={vp.name}
                id="bg-nested-dropdown"
                style={{ fontWeight: 'bold' }}
              >
                {valuePropositions.map((el, idx) => (
                  <MenuItem
                    key={idx}
                    href="#"
                    onClick={() =>
                      (window.location.href = `/value_propositions/${el.id}/set_current_vp`)
                    }
                  >
                    {el.name}
                  </MenuItem>
                ))}
              </DropdownButton>
            )}
          </Col>

          <Col xs={12} md={4} className="vp-dropdown">
            {title && vp && (
              <p
                className="vp-picker"
                title={intl.formatMessage({ id: 'current_goal_title' })}
                // className="vp-title"
              >
                {intl.formatMessage({ id: 'current_goal' })}
              </p>
            )}
            {vp && (
              <DropdownButton
                pullRight
                title={intl.formatMessage({ id: vp.current_goal })}
                id="omtm-dropdown"
                style={{ fontWeight: 'bold' }}
                disabled={this.cannotUpdateCurrentGoal()}
                noCaret={this.cannotUpdateCurrentGoal()}
              >
                {Goals.map(goal => (
                  <MenuItem
                    key={goal}
                    href={'#'}
                    onClick={() =>
                      (window.location.href = `/value_propositions/${vp.id}/set_current_goal/${goal}`)
                    }
                  >
                    {intl.formatMessage({ id: goal })}
                  </MenuItem>
                ))}
              </DropdownButton>
            )}
          </Col>
          <Col xs={12} md={4} className="vp-dropdown">
            {this.bmcStore && !this.bmcStore.loading && (
              <React.Fragment>
                <p
                  className="vp-picker"
                  title={intl.formatMessage({
                    id: 'train_of_clients_title'
                  })}
                >
                  {intl.formatMessage({ id: 'train_of_clients' })}
                </p>

                <DropdownButton
                  pullRight
                  title={intl.formatMessage({
                    id:
                      (this.bmcStore && this.bmcStore.currentStage) ||
                      currentBoardStage
                  })}
                  id="current-stage-dropdown"
                  style={{ fontWeight: 'bold' }}
                  disabled={
                    !this.bmcStore ||
                    this.cannotUpdateToC() ||
                    updatingCurrStage
                  }
                  noCaret={
                    !this.bmcStore ||
                    this.cannotUpdateToC() ||
                    updatingCurrStage
                  }
                >
                  {Object.values(BMC_STAGES).map((val, index) => (
                    <MenuItem
                      key={val}
                      value={val}
                      disabled={!this.bmcStore.isValidNewStage(val)}
                      onSelect={() => this.updateCurrentBmcStage(val)}
                    >
                      <p
                        style={{
                          ...(this.bmcStore.currentStage === val
                            ? { color: '#16a085' }
                            : {}),
                          ...(this.bmcStore.currentStage === val ||
                          this.bmcStore.isValidNewStage(val)
                            ? { fontWeight: 'bold' }
                            : {}),
                          padding: '4px'
                        }}
                      >
                        {intl.formatMessage({ id: val })}
                      </p>
                    </MenuItem>
                  ))}
                </DropdownButton>
              </React.Fragment>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
